// src/pages/TransferEntry/components/CreateTransferForm.js
import { Form, Button, Typography, Card, Flex, DatePicker, Grid,  Drawer, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TransferItemsTable from "./TransferItemsTable";
import TransferFooter from "./TransferFooter";
import { setFormField } from "../TransferEntrySlice";
import { ArrowLeftOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import InputField from "../../../components/Input/Input";
import SearchAutoComplete from "../../../components/SearchAutoComplete";
import { useNavigate } from "react-router-dom";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { useEffect, useState } from "react";
import { getAccessType } from "../../../lib/functions";
import useMigrationDate from "../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateTransferForm = ({
  form,
  onSave,
  voucherNo,
  itemsList,
  footerValues,
  authInfo
}) => {
  const dispatch = useDispatch();
  let [access_type, access_type_set] = useState("");
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    const access = getAccessType("transfer_entry");
    access_type_set(access);
  }, []);

  const { entryDate, branchDetails } = useSelector((s) => s.transferEntry);
  const navigate = useNavigate();

  // Mock options (replace with your API-fetched data)
  const branches = useSelector((state) => state.transferEntry.branches);

  const screens = useBreakpoint();

  const branchOptions = (branches || []).map((b) => ({
    value: b.id,
    display_text: b.name,
    address: b.address,
  }));

  const handleNavigateToBack = () => {
    navigate("/inventory/dashboard");
  };

  const {disabledDate}= useMigrationDate();

  const handleBranchSelect = (br) => { 
    if (br) { 
      dispatch(
        setFormField({
          field: "branchDetails",
          value: {
            id: br.sale_id,
            name: br.display_text,
            address: br.address,
            margin: Number(br.margin) || 0,  
          },
        })
      );
    }
  };

  return (
    <div className="transfer-entry-form">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: "22px" }} />}
          onClick={handleNavigateToBack}
          style={{
            marginRight: 12,
            padding: 0,
            height: "auto",
            lineHeight: "1",
            color: "#000",
          }}
        />

        <Title level={2} style={{ margin: 0 }}>
          Transfer Entry
        </Title>

        <div style={{ marginLeft: "auto" }}>
          <Tooltip title="Help">
            <Button
              type="text"
              icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
              onClick={() => setHelpOpen(true)}
            />
          </Tooltip>
        </div>
      </div>
      <Form
        form={form}
        layout="horizontal"
        //  onFinish={submitForm}
        initialValues={{ variant: "filled" }}
        style={{ width: "100%", maxWidth: "1200px" }}
        // className="responsive-form"
        colon={false}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 18,
        }}
      >
        {!screens.xs && <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="flex-start"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex gap={16}>
            <Button
              size="large"
              className="traic-button"
              shape="default"
              onClick={handleNavigateToBack}
            >
              Back
            </Button>
            {access_type == "WRITE" && <>
              <Button
                type="primary"
                size="large"
                // onClick={submitForm}
                className="traic-button"
                disabled={false}
              >
                Save
              </Button>
            </>}
          </Flex>
        </Flex>}

        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{
              width: !screens.md || !screens.xl ? "100%" : "40%",
            }}
          >
            <Form.Item
              label="To Branch"
              // name={"to_branch"}
              required
              rules={[{ required: true, message: "To Branch" }]}
            >
              <SearchListAutoComplete
                entityType="To Branch"

                optionsList={branches.map((b) => ({
                  sale_id: b.id,
                  display_text: b.name,
                  address: b.address,
                  margin: b.margin_rate || 0,   // ✅ ADD THIS LINE

                }))}

                value={
                  branchDetails?.id
                    ? {
                        sale_id: branchDetails.id,
                        display_text: branchDetails.name,
                      }
                    : null
                }
                // resultSelector={(state) =>
                //   (state.transferEntry.branches || []).map((b) => ({
                //     value: b.id,
                //     display_text: b.name,
                //     address: b.address,
                //   }))
                // }
                onSelect={(value, option) => {
                  handleBranchSelect(option || value);
                }}
                placeholder="To Branch"
                data-testid="to-branch-select"
                showAddNew={false}
              />
            </Form.Item>
            <Form.Item label="Branch Address" style={{ flex: 1 }}>
              <InputField disabled value={branchDetails?.address || ""} />
            </Form.Item>
          </Flex>
          <Flex
            vertical
            gap={10}
            style={{
              width: !screens.md || !screens.xl ? "100%" : "40%",
            }}
          >
            <Form.Item label="Voucher No" style={{ flex: 1 }}>
              <InputField disabled value={voucherNo} />
            </Form.Item>
            <Form.Item label="Entry Date" style={{ flex: 1 }}>
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(date) =>
                  dispatch(
                    setFormField({
                      field: "entryDate",
                      value: date ? date.toISOString() : null,
                    })
                  )
                }
                   disabledDate={disabledDate}
              />
            </Form.Item>
          </Flex>
        </Flex>
      </Form>

      {/* Items Table */}
      <Card
        bordered
        style={{ marginBottom: 24 }}
        title={
          <Title level={4} style={{ margin: 0 }}>
            Transfer Items
          </Title>
        }
      >
        <div style={{ width: "100%", maxWidth: "1300px" }}>
        <TransferItemsTable itemsList={itemsList} />
        </div>
      </Card>

      {/* Footer Totals */}
      <TransferFooter footerValues={footerValues} authInfo={authInfo} />

      {/* Narration */}
      {/* <Form.Item label="Description / Narration">
        <Input.TextArea
          rows={3}
          value={footerValues.narration}
          onChange={(e) =>
            dispatch(
              setFormField({
                field: "footerValues",
                value: { ...footerValues, narration: e.target.value },
              })
            )
          }
        />
      </Form.Item> */}

      {/* Buttons */}

      <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
        <Button
          size="large"
          shape="default"
          onClick={handleNavigateToBack}
          className="traic-button"
        >
          Back
        </Button>
        {access_type == "WRITE" && <>
          <Button
            type="primary"
            className="traic-button"
            size="large"
            onClick={onSave}
            disabled={false}
            data-testid="save-transfer-entry"
          >
            Save
          </Button>
        </>}
      </Flex>
      <Drawer
        title="Transfer Entry Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Transfer Entry
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Transfer Entry module is used to transfer inventory items
            between branches or warehouse locations within the ERP system.
            It helps maintain accurate stock movement tracking and inventory control.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Transfer Entry</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Transfer Entry</strong></li>
              <li>Select the destination branch</li>
              <li>Verify branch address details</li>
              <li>Check voucher number and entry date</li>
              <li>Add transfer items and quantities</li>
              <li>Review item totals and stock details</li>
              <li>Verify transfer information carefully</li>
              <li>Click <strong>Save</strong> to complete transfer entry</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Transfer entries directly affect branch stock balances.</li>
              <li>Verify quantities carefully before saving transfers.</li>
              <li>Branch selection determines destination stock movement.</li>
              <li>Transfer records are maintained for inventory tracking and auditing.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateTransferForm;
